<template>
  <div>
    <b-card header-tag="header" no-body>
      <template #header>
        <header-sagres titulo="Informações do edital" breakpoint="xl" />
      </template>
      <b-overlay :show="overlayCard">
        <b-card-body>
          <b-container class="mt-3">
            <validation-observer
              ref="validationobserver"
              v-slot="{ handleSubmit }"
            >
              <b-form @submit.prevent="handleSubmit(salvarEdital)">
                <b-row style="text-align: left" v-if="ehSEAD">
                  <b-col cols="16" lg="6">
                    <default-form-validation-provider label="UG" tag="div">
                      <div
                        id="ugSelectWrapper"
                        :class="{
                          invalid: !UGSelecionada || !UGSelecionada.value,
                          valid: !!UGSelecionada && !!UGSelecionada.value,
                        }"
                      >
                        <multiselect
                          v-model="UGSelecionada"
                          open-direction="bottom"
                          placeholder="Selecione uma UG"
                          track-by="value"
                          :options="listaUGsSelect"
                          :allow-empty="true"
                          label="text"
                          close-on-select
                          searchable
                          deselect-label=""
                          :show-labels="false"
                          :disabled="detalhes"
                        >
                          <template slot="noOptions">
                            <small><i>Erro ao obter dados.</i></small>
                          </template>
                          <template slot="noResult">
                            <i>Sem resultados.</i>
                          </template>
                        </multiselect>
                      </div>
                    </default-form-validation-provider>
                  </b-col>
                </b-row>
                <b-row style="text-align: left">
                  <b-col cols="12" lg="3">
                    <default-form-validation-provider
                      v-slot="defaultState"
                      label="Número do edital"
                      rules="required|min_value:1"
                    >
                      <b-form-input
                        v-model="edital.NrEdital"
                        type="number"
                        min="1"
                        placeholder="Digite o número do edital"
                        :state="defaultState.state"
                        :disabled="detalhes"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="3">
                    <default-form-validation-provider
                      v-slot="defaultState"
                      label="Ano do edital"
                      rules="required|min_value:1900|max_value:2125"
                    >
                      <b-form-input
                        v-model="edital.AnoEdital"
                        type="number"
                        min="1900"
                        placeholder="Digite o ano do edital"
                        :state="defaultState.state"
                        :disabled="detalhes"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <default-form-validation-provider
                      v-slot="defaultState"
                      label="Tipo do edital"
                    >
                      <b-input-group>
                        <b-form-select
                          v-model="edital.IdTipoEdital"
                          :options="listaTipoEdital"
                          :state="defaultState.state"
                          :disabled="detalhes"
                          @change="mudaFlPeriodo"
                        />
                        <b-input-group-append v-if="edital.IdTipoEdital === 2">
                          <b-button
                            size="sm"
                            class="btn btn-info align-items-center"
                            data-toggle="tooltip"
                            title="Saúde e combate a endemias"
                            ><b>?</b></b-button
                          >
                        </b-input-group-append>
                      </b-input-group>
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <default-form-validation-provider
                      v-slot="defaultState"
                      label="Data Publicação Edital: "
                    >
                      <b-form-datepicker
                        id="input-data-publicacao-edital"
                        :state="defaultState.state"
                        v-model="edital.DtPublicacao"
                        v-bind="datePickerProps"
                        size="sm"
                        :disabled="detalhes"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <default-form-validation-provider
                      v-slot="defaultState"
                      label="Regime de Execução"
                    >
                      <b-input-group>
                        <b-form-select
                          v-model="edital.IdTipoRegime"
                          :options="listaTipoRegime"
                          :state="defaultState.state"
                          :disabled="detalhes"
                        />
                        <b-input-group-append
                          v-if="edital.IdTipoRegime !== null"
                        >
                          <b-button
                            size="sm"
                            class="btn btn-info align-items-center"
                            data-toggle="tooltip"
                            :title="
                              edital.IdTipoRegime == 1
                                ? 'Dispensa Licitação'
                                : 'Exige Licitação'
                            "
                            ><b>?</b></b-button
                          >
                        </b-input-group-append>
                      </b-input-group>
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="6" v-if="edital.IdTipoRegime === 2">
                    <b-overlay :show="overlayBancaSelect">
                      <default-form-validation-provider
                        v-slot="defaultState"
                        label="Inst. Realizadora"
                        tag="div"
                      >
                        <div
                          id="selectWrapper"
                          :class="{
                            invalid:
                              !BancaSelecionada ||
                              !BancaSelecionada?.value ||
                              BancaSelecionada?.value === null ||
                              !(Number(BancaSelecionada?.value) >= 1),
                            valid: Number(BancaSelecionada?.value) > 0,
                          }"
                        >
                          <multiselect
                            v-model="BancaSelecionada"
                            open-direction="bottom"
                            :state="defaultState.state"
                            placeholder="Selecione uma Inst. Realizadora"
                            track-by="value"
                            :options="listaBancasSelect"
                            :allow-empty="true"
                            label="text"
                            close-on-select
                            searchable
                            deselect-label=""
                            :show-labels="false"
                            @select="onSelectBanca"
                            :disabled="detalhes"
                          >
                            <template slot="noOptions">
                              <small><i>Erro ao obter dados.</i></small>
                            </template>
                            <template slot="noResult">
                              <i>Sem resultados.</i>
                            </template>
                          </multiselect>
                        </div>
                      </default-form-validation-provider>
                    </b-overlay>
                  </b-col>
                  <b-col cols="12" lg="6" v-if="edital.IdTipoRegime === 2">
                    <b-overlay :show="overlayLicitacoes">
                      <default-form-validation-provider
                        label="Processo Licitatório"
                        tag="div"
                        v-slot="defaultState"
                      >
                        <div
                          v-if="habilitaIgesp"
                          id="inputWrapper"
                          :class="{
                            invalid:
                              edital.CodLicitacaoIgesp == null ||
                              (edital.CodLicitacaoIgesp !== null &&
                                edital.CodLicitacaoIgesp !== undefined &&
                                edital.CodLicitacaoIgesp.length < 16),
                            valid:
                              edital.CodLicitacaoIgesp !== null &&
                              edital.CodLicitacaoIgesp !== undefined &&
                              edital.CodLicitacaoIgesp.length === 16,
                          }"
                        >
                          <b-form-input
                            v-model="edital.CodLicitacaoIgesp"
                            placeholder="Digite o código IGESP da licitação"
                            type="text"
                            minlength="16"
                            maxlength="16"
                            :disabled="detalhes"
                          />
                        </div>
                        <div
                          v-else
                          id="selectWrapper"
                          :class="{
                            invalid:
                              !LicitacaoSelecionada ||
                              !LicitacaoSelecionada?.value ||
                              LicitacaoSelecionada?.value === null ||
                              !(Number(LicitacaoSelecionada?.value) >= 1),
                            valid: Number(LicitacaoSelecionada?.value) > 0,
                          }"
                        >
                          <multiselect
                            v-model="LicitacaoSelecionada"
                            open-direction="bottom"
                            placeholder="Selecione um Processo Licitatório"
                            track-by="value"
                            :options="listaLicitacoes"
                            :allow-empty="true"
                            label="text"
                            close-on-select
                            searchable
                            deselect-label=""
                            :show-labels="false"
                            :disabled="detalhes"
                            :state="defaultState.state"
                          >
                            <template slot="noOptions">
                              <small><i>Erro ao obter dados.</i></small>
                            </template>
                            <template slot="noResult">
                              <i>Sem resultados.</i>
                            </template>
                          </multiselect>
                        </div>
                      </default-form-validation-provider>
                    </b-overlay>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <default-form-validation-provider
                      v-slot="defaultState"
                      label="Início Inscrição"
                    >
                      <b-form-datepicker
                        id="input-data-inicio-inscricao"
                        :state="defaultState.state"
                        v-model="edital.DtInicioInscricao"
                        v-bind="datePickerProps"
                        size="sm"
                        :disabled="detalhes"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <default-form-validation-provider
                      label="Fim Inscrição"
                      v-slot="defaultState"
                    >
                      <b-form-datepicker
                        id="input-data-fim-inscricao"
                        :state="defaultState.state"
                        v-model="edital.DtFimInscricao"
                        v-bind="datePickerProps"
                        size="sm"
                        :disabled="detalhes"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col v-if="prazoInscricaoInsuficiente" cols="12">
                    <b-alert show variant="warning" class="py-2 mb-0">
                      <font-awesome-icon
                        icon="triangle-exclamation"
                        class="mr-1"
                      />
                      Concurso público com prazo de inscrição inferior a 15
                      dias.
                    </b-alert>
                  </b-col>
                  <b-col cols="12" lg="3" v-if="!flPeriodoProva || detalhes">
                    <default-form-validation-provider
                      :label="
                        flPeriodoProva && detalhes
                          ? 'Data Inicial da Avaliação'
                          : 'Data da Avaliação'
                      "
                      v-slot="defaultState"
                    >
                      <b-form-datepicker
                        id="input-data-prova"
                        :state="defaultState.state"
                        v-model="edital.DtProva"
                        v-bind="datePickerProps"
                        size="sm"
                        :disabled="detalhes"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="3" v-if="!detalhes && flPeriodoProva">
                    <date-range-picker-base
                      v-model="periodoProva"
                      title="Período da Avaliação"
                    />
                  </b-col>
                  <b-col sm="6" lg="3" v-if="!detalhes">
                    <default-form-validation-provider
                      rules=""
                      label=""
                      v-slot="defaultState"
                      v-if="edital.IdTipoEdital !== 1"
                    >
                      <b-form-checkbox
                        :state="defaultState.state"
                        v-model="flPeriodoProva"
                        >Avaliação realizada em período</b-form-checkbox
                      >
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="6" v-if="detalhes && flPeriodoProva">
                    <default-form-validation-provider
                      label="Data Final da Avaliação"
                      v-slot="defaultState"
                    >
                      <b-form-datepicker
                        id="input-data-prova-final"
                        :state="defaultState.state"
                        v-model="edital.DtProvaFinal"
                        v-bind="datePickerProps"
                        size="sm"
                        :disabled="true"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <!-- Se concurso, validade até 24 meses. Se não, até 12 meses -->
                    <default-form-validation-provider
                      label="Validade (meses)"
                      v-slot="defaultState"
                      :rules="`required|min_value:1|max_value:${
                        edital.IdTipoEdital === 1 ? '24' : '12'
                      }`"
                    >
                      <b-form-input
                        v-model="edital.Validade"
                        placeholder="Digite a validade"
                        type="number"
                        min="1"
                        :max="edital.IdTipoEdital === 1 ? '24' : '12'"
                        :state="defaultState.state"
                        :disabled="detalhes"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="6" v-if="edital.IdTipoEdital === 1">
                    <default-form-validation-provider
                      label="Dotação Orçamentária"
                      v-slot="defaultState"
                    >
                      <b-form-input
                        v-model="edital.DsDotacaoOrcamentaria"
                        placeholder="Digite autorização na LOA"
                        type="text"
                        :state="defaultState.state"
                        :disabled="detalhes"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="6" v-if="edital.IdTipoEdital === 1">
                    <default-form-validation-provider
                      label="Artigo específico do LDO"
                      v-slot="defaultState"
                    >
                      <b-form-input
                        v-model="edital.DsAutorizacaoLDO"
                        placeholder="Digite o artigo específico da LDO"
                        type="text"
                        :state="defaultState.state"
                        :disabled="detalhes"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col sm="6" lg="3">
                    <default-form-validation-provider
                      rules=""
                      label=""
                      v-slot="defaultState"
                    >
                      <b-form-checkbox
                        :state="defaultState.state"
                        v-model="edital.FlPermiteProrrogacao"
                        :disabled="detalhes"
                        >Prorrogável</b-form-checkbox
                      >
                    </default-form-validation-provider>
                  </b-col>
                  <b-col sm="6" lg="3">
                    <default-form-validation-provider
                      rules=""
                      label=""
                      v-slot="defaultState"
                    >
                      <b-form-checkbox
                        :state="defaultState.state"
                        v-model="edital.FlDevolucaoTaxaInscricao"
                        :disabled="detalhes"
                        >Previsão de formas de devolução da taxa de
                        inscrição</b-form-checkbox
                      >
                    </default-form-validation-provider>
                  </b-col>
                  <b-col sm="6" lg="3">
                    <default-form-validation-provider
                      rules=""
                      label=""
                      v-slot="defaultState"
                    >
                      <b-form-checkbox
                        :state="defaultState.state"
                        v-model="edital.FlIsencao"
                        :disabled="detalhes"
                        >Previsão de isenção</b-form-checkbox
                      >
                    </default-form-validation-provider>
                  </b-col>
                  <b-col sm="6" lg="3">
                    <default-form-validation-provider
                      rules=""
                      label=""
                      v-slot="defaultState"
                    >
                      <b-form-checkbox
                        :state="defaultState.state"
                        v-model="edital.FlInscricaoEstrangeiros"
                        :disabled="detalhes"
                        >Previsão de Inscrição de Estrangeiros</b-form-checkbox
                      >
                    </default-form-validation-provider>
                  </b-col>
                  <b-col sm="6" lg="3">
                    <default-form-validation-provider
                      rules=""
                      label=""
                      v-slot="defaultState"
                    >
                      <b-form-checkbox
                        :state="defaultState.state"
                        v-model="edital.FlCritDesempateEstatutoIdoso"
                        :disabled="detalhes"
                        >Critérios de Desempate observam o estatuto do
                        idoso</b-form-checkbox
                      >
                    </default-form-validation-provider>
                  </b-col>
                  <b-col sm="6" lg="3">
                    <default-form-validation-provider
                      rules=""
                      label=""
                      v-slot="defaultState"
                    >
                      <b-form-checkbox
                        :state="defaultState.state"
                        v-model="edital.FlRecursosTodasFases"
                        :disabled="detalhes"
                        >Recursos em todas as fases</b-form-checkbox
                      >
                    </default-form-validation-provider>
                  </b-col>
                  <b-col sm="6" lg="3">
                    <default-form-validation-provider
                      rules=""
                      label=""
                      v-slot="defaultState"
                    >
                      <b-form-checkbox
                        :state="defaultState.state"
                        v-model="edital.FlPublicacaoTodasFases"
                        :disabled="detalhes"
                        >Publicação em todas as fases</b-form-checkbox
                      >
                    </default-form-validation-provider>
                  </b-col>
                  <b-col sm="6" lg="3" />
                  <b-col sm="12" lg="6">
                    <default-form-validation-provider
                      rules=""
                      label=""
                      v-slot="defaultState"
                    >
                      <b-form-checkbox
                        :state="defaultState.state"
                        v-model="edital.FlTempoExperienciaLei"
                        :disabled="detalhes"
                        >Tempo de Experiência Fundamentado em
                        Lei</b-form-checkbox
                      >
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <default-form-validation-provider
                      v-if="edital.FlTempoExperienciaLei"
                      label="Lei referente ao tempo de experiência"
                      v-slot="defaultState"
                    >
                      <b-input
                        v-model="edital.DsTempoExperienciaLei"
                        placeholder="Digite a lei referente ao tempo de experiência"
                        :state="defaultState.state"
                        :disabled="detalhes"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col sm="12" lg="6">
                    <default-form-validation-provider
                      rules=""
                      label=""
                      v-slot="defaultState"
                    >
                      <b-form-checkbox
                        :state="defaultState.state"
                        v-model="edital.FlExamePsicotecnico"
                        :disabled="detalhes"
                        >Exame psicotécnico</b-form-checkbox
                      >
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <default-form-validation-provider
                      v-if="edital.FlExamePsicotecnico"
                      label="Lei referente ao exame psicotécnico"
                      v-slot="defaultState"
                    >
                      <b-input
                        v-model="edital.DsExamePsicotecnico"
                        placeholder="Digite a lei referente ao exame psicotécnico"
                        :state="defaultState.state"
                        :disabled="detalhes"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col sm="12" lg="6">
                    <default-form-validation-provider
                      rules=""
                      label=""
                      v-slot="defaultState"
                    >
                      <b-form-checkbox
                        :state="defaultState.state"
                        v-model="edital.FlVagasCotas"
                        :disabled="detalhes"
                        >Vagas Cotas</b-form-checkbox
                      >
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <default-form-validation-provider
                      v-if="edital.FlVagasCotas"
                      label="Lei referente às vagas com cotas"
                      v-slot="defaultState"
                    >
                      <b-form-input
                        v-model="edital.DsVagasCotas"
                        placeholder="Digite a lei referente às vagas com cotas"
                        :state="defaultState.state"
                        :disabled="detalhes"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col sm="12" lg="6">
                    <default-form-validation-provider
                      rules=""
                      label=""
                      v-slot="defaultState"
                    >
                      <b-form-checkbox
                        :state="defaultState.state"
                        v-model="edital.FlVagasPcd"
                        :disabled="detalhes"
                        >Vagas PCD</b-form-checkbox
                      >
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <default-form-validation-provider
                      v-if="edital.FlVagasPcd"
                      label="Lei referente às vagas para PCDs"
                      v-slot="defaultState"
                    >
                      <b-form-input
                        v-model="edital.DsVagasPcd"
                        placeholder="Digite a lei referente às vagas para PCDs"
                        :state="defaultState.state"
                        :disabled="detalhes"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col sm="12" lg="6">
                    <default-form-validation-provider
                      rules=""
                      label=""
                      v-slot="defaultState"
                    >
                      <b-form-checkbox
                        :state="defaultState.state"
                        v-model="edital.FlProvaOral"
                        :disabled="detalhes"
                        >Prova oral</b-form-checkbox
                      >
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <default-form-validation-provider
                      v-if="edital.FlProvaOral"
                      label="Lei referente à prova oral"
                      v-slot="defaultState"
                    >
                      <b-form-input
                        v-model="edital.DsProvaOral"
                        placeholder="Digite a lei referente à prova oral"
                        :state="defaultState.state"
                        :disabled="detalhes"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col sm="12" lg="6">
                    <default-form-validation-provider
                      rules=""
                      label=""
                      v-slot="defaultState"
                    >
                      <b-form-checkbox
                        :state="defaultState.state"
                        v-model="edital.FlTaf"
                        :disabled="detalhes"
                        >Teste de Aptidão Física (TAF)</b-form-checkbox
                      >
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <default-form-validation-provider
                      v-if="edital.FlTaf"
                      label="Lei referente ao TAF"
                      v-slot="defaultState"
                    >
                      <b-form-input
                        v-model="edital.DsTaf"
                        placeholder="Digite a lei referente ao TAF"
                        :state="defaultState.state"
                        :disabled="detalhes"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col
                    cols="12"
                    lg="6"
                    v-if="edital.IdEdital && edital.DtHomologacao"
                  >
                    <default-form-validation-provider
                      rules=""
                      label="Data de Homologação"
                    >
                      <b-form-datepicker
                        id="data-homologacao"
                        v-model="edital.DtHomologacao"
                        :disabled="true"
                        size="sm"
                        v-bind="datePickerProps"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col
                    cols="12"
                    lg="6"
                    v-if="edital.IdEdital && edital.DtValidade"
                  >
                    <default-form-validation-provider
                      rules=""
                      label="Data de Validade"
                    >
                      <b-form-datepicker
                        id="data-validade"
                        v-model="edital.DtValidade"
                        :disabled="true"
                        size="sm"
                        v-bind="datePickerProps"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col
                    cols="12"
                    lg="6"
                    v-if="edital.IdEdital && edital.DtCancelamento"
                  >
                    <default-form-validation-provider
                      rules=""
                      label="Data de Cancelamento"
                    >
                      <b-form-datepicker
                        id="data-cancelamento"
                        v-model="edital.DtCancelamento"
                        :disabled="true"
                        size="sm"
                        v-bind="datePickerProps"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="12" class="text-right">
                    <b-button
                      type="submit"
                      variant="secondary"
                      size="sm"
                      v-if="!detalhes"
                    >
                      <font-awesome-icon icon="floppy-disk" /> Salvar</b-button
                    >
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-container>
        </b-card-body>
      </b-overlay>
    </b-card>

    <validation-observer
      ref="validationobserver"
      v-slot="{ handleSubmitModal }"
    >
      <b-modal
        id="modal-1"
        header-bg-variant="secondary"
        header-text-variant="light"
        centered
        no-close-on-backdrop
        no-close-on-esc
      >
        <template v-slot:modal-header="">
          <h5>Cadastrar Instituição</h5>
        </template>
        <b-form @submit.prevent="handleSubmitModal(adicionarInstituicao)">
          <b-container>
            <b-col cols="12">
              <default-form-validation-provider label="Nome da banca">
                <b-form-input
                  v-model="camposEnvioBanca.NomeBanca"
                  placeholder="Digite o nome da banca"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12">
              <default-form-validation-provider
                label="CNPJ da banca"
                rules="required|max_value:99999999999999"
              >
                <b-form-input
                  v-model="camposEnvioBanca.CnpjBanca"
                  type="number"
                  placeholder="Digite o CNPJ da banca"
                  max="99999999999999"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12">
              <default-form-validation-provider label="Telefone da banca">
                <vue-tel-input
                  v-model="camposEnvioBanca.FoneBanca"
                  :props="vueTelOptions"
                  :inputOptions="telPlaceholder"
                />
              </default-form-validation-provider>
            </b-col>
          </b-container>
        </b-form>
        <template #modal-footer>
          <b-button size="sm" variant="outline-secondary" @click="fecharModal">
            Fechar
          </b-button>
          <b-button
            size="sm"
            variant="secondary"
            @click="adicionarInstituicao"
            :disabled="
              !camposEnvioBanca.NomeBanca ||
              !camposEnvioBanca.CnpjBanca ||
              camposEnvioBanca.CnpjBanca.length < 14 ||
              !camposEnvioBanca.FoneBanca ||
              camposEnvioBanca.FoneBanca.length < 14 ||
              camposEnvioBanca.FoneBanca.length > 15 ||
              BancaSelecionada.value === null ||
              detalhes
            "
          >
            Adicionar</b-button
          >
        </template>
      </b-modal>
    </validation-observer>
  </div>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import Multiselect from "vue-multiselect";
import { mixins } from "vue-class-component";
import { ValidationObserver } from "vee-validate";
import { SelectValue } from "@/types/select-value";
import { BotaoSagres } from "@/types/botao-sagres";
import { Banca } from "@/types/atos-pessoal/concursos/banca";
import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import { DatePickerDefaultProps } from "@/types/form-default-props";
import { MultiSelectDefaultProps } from "@/types/form-default-props";
import concursoService from "@/services/atos-pessoal/concursoService";
import { EditalConcurso } from "@/types/atos-pessoal/concursos/edital";
import { ProcessoLicitatorio } from "@/types/atos-pessoal/concursos/processo-licitatorio";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import DateRangePickerBase from "@/components/shared/DateRangePickerBase.vue";
import { EditalEnvio } from "@/types/atos-pessoal/concursos/edital-envio";
import ugService from "@/services/administracao/ugService";

const CompProps = Vue.extend({
  name: "AbaCadastroConcurso",
  components: {
    Multiselect,
    HeaderSagres,
    ValidationObserver,
    DefaultFormValidationProvider,
    DateRangePickerBase,
  },
  props: {
    idEdital: {
      type: Number,
      required: true,
    },
    detalhes: {
      type: Boolean,
      default: false,
    },
  },
});

@Component
export default class AbaCadastroConcurso extends mixins(UtilsTS, CompProps) {
  @Ref("validationobserver") validationobserver: InstanceType<
    typeof ValidationObserver
  >;

  BancaSelecionada: SelectValue = { text: "Selecione uma opção", value: null };
  LicitacaoSelecionada: SelectValue = {
    text: "Selecione uma opção",
    value: null,
  };

  datePickerProps = DatePickerDefaultProps;
  multiselectprops = MultiSelectDefaultProps;
  botoesHeader: BotaoSagres[] = [
    {
      id: -1,
      icone: "arrow-left",
      texto: "Voltar",
    },
  ];

  edital: any = new EditalConcurso();
  flPeriodoProva = false;
  periodoProva: { startDate: any; endDate: any } = {
    startDate: null,
    endDate: null,
  };

  idEditalAtualizado: number;
  editalCriado = false;

  campos: EditalEnvio = {
    idTipoEdital: 0,
    idBanca: 0,
    nrEdital: 0,
    anoEdital: 0,
    validade: 0,
    dispensaLicitacao: false,
    flPermiteProrrogacao: true,
    IdLicitacao: null,
    dtPublicacao: "",
    dtInicioInscricao: "",
    dtFimInscricao: "",
    dtProva: "",
    dtProvaFinal: "",
    DsDotacaoOrcamentaria: "",
    DsAutorizacaoLDO: "",
    IdTipoRegime: 0,
    FlProvaOral: false,
    FlExamePsicotecnico: false,
    DsProvaOral: "",
    DsExamePsicotecnico: "",
    FlTempoExperienciaLei: false,
    FlDevolucaoTaxaInscricao: false,
    FlIsencao: false,
    FlInscricaoEstrangeiros: false,
    FlCritDesempateEstatutoIdoso: false,
    FlRecursosTodasFases: false,
    FlPublicacaoTodasFases: false,
    codLicitacaoIgesp: null,
    FlVagasPcd: false,
    DsVagasPcd: "",
    FlVagasCotas: false,
    DsVagasCotas: "",
    DsTempoExperienciaLei: "",
    codUgResponsavel: null,
  };

  listaUGsSelect: SelectValue[] = [];
  UGSelecionada: SelectValue = { text: "Selecione uma UG", value: null };

  camposEnvioBanca: Banca = {
    IdBanca: -2,
    NomeBanca: "",
    CnpjBanca: "",
    FoneBanca: "",
  };

  listaBancasGeral: Banca[] = [];

  listaLicitacoes: SelectValue[] = [];
  listaBancasSelect: SelectValue[] = [];
  listaTipoRegime: SelectValue[] = [
    { text: "Selecione uma opção", value: null },
    { text: "Direto", value: 1 },
    { text: "Indireto", value: 2 },
  ];
  listaTipoEdital: SelectValue[] = [
    { text: "Selecione uma opção", value: null },
    { text: "Concurso", value: 1 },
    { text: "Processo Seletivo Público", value: 2 },
    { text: "Processo Seletivo Simplificado", value: 3 },
  ];

  overlayCard = false;
  overlayLicitacoes = false;
  overlayBancaSelect = false;
  habilitaIgesp = false;
  carregandoDados = false;
  ignorarProximaMudancaTipoEdital = false;
  ehSEAD = false;

  telPlaceholder = {
    placeholder: "Digite o telefone da banca",
  };

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    try {
      this.carregandoDados = true;
      await this.loadUgs();
      this.edital.IdEdital = this.idEdital;
      if (this.idEdital > 0) await this.getConcursoById(this.idEdital);
      else {
        this.edital.IdTipoEdital = null;
        this.edital.IdBanca = null;
      }
      const ugEncontrada = this.listaUGsSelect.find(
        (ug) => ug.value === this.edital.CodUgSagres
      );
      this.UGSelecionada = ugEncontrada ?? {
        text: "Selecione uma opção",
        value: null,
      };
      await this.insituicoesSelect();
      this.BancaSelecionada = {
        value: this.edital.IdBanca,
        text: this.edital.IdBancaNavigation?.NomeBanca,
      };
      if (this.BancaSelecionada.text == undefined)
        this.BancaSelecionada.text = "Selecione uma opção";
      this.edital.DispensaLicitacao
        ? (this.edital.IdTipoRegime = 1)
        : (this.edital.IdTipoRegime = 2);
      if (!(this.idEdital > 0)) this.edital.IdTipoRegime = null;
      this.habilitaIgesp = await this.habilitaCodIgespLicitacao();
      if (!this.habilitaIgesp) await this.getListarLicitacoes();
    } finally {
      this.carregandoDados = false;
    }
  }

  async loadUgs() {
    try {
      const response = await concursoService.getAllUgs();
      this.listaUGsSelect = response.map((ug: any) => ({
        text: ug.NmNome,
        value: ug.CodUgSagres,
      }));
      this.ehSEAD = true;
    } catch (e: unknown) {
      console.error("Erro ao carregar UGs", e);
      this.ehSEAD = false;
    }
  }

  parseDateAsLocal(dateStr: string | Date | null): Date | null {
    if (!dateStr) return null;
    if (dateStr instanceof Date) return dateStr;
    const str = String(dateStr).split("T")[0];
    const [year, month, day] = str.split("-").map(Number);
    if (isNaN(year) || isNaN(month) || isNaN(day)) return null;
    return new Date(year, month - 1, day);
  }

  @Watch("flPeriodoProva")
  onFlPeriodoProvaChange(val: boolean) {
    if (val) {
      this.periodoProva = {
        startDate: this.parseDateAsLocal(this.edital.DtProva),
        endDate: this.parseDateAsLocal(
          this.edital.DtProvaFinal ?? this.edital.DtProva
        ),
      };
    }
  }

  @Watch("edital.IdTipoEdital")
  async onTipoEditalChange(
    novoTipoEdital: number | null,
    tipoEditalAnterior: number | null
  ) {
    if (this.ignorarProximaMudancaTipoEdital) {
      this.ignorarProximaMudancaTipoEdital = false;
      return;
    }

    if (
      this.carregandoDados ||
      this.detalhes ||
      this.idEdital <= 0 ||
      novoTipoEdital === tipoEditalAnterior
    ) {
      return;
    }

    const confirmou = await this.confirmarTrocaTipoEdital(
      tipoEditalAnterior,
      novoTipoEdital
    );

    if (confirmou) return;

    this.ignorarProximaMudancaTipoEdital = true;
    this.edital.IdTipoEdital = tipoEditalAnterior ?? null;
  }

  getDescricaoTipoEdital(tipoId: number | null) {
    const tipo = this.listaTipoEdital.find((item) => item.value === tipoId);
    return tipo?.text || "Não informado";
  }

  async confirmarTrocaTipoEdital(
    tipoAnterior: number | null,
    novoTipo: number | null
  ) {
    const descricaoAnterior = this.getDescricaoTipoEdital(tipoAnterior);
    const descricaoNova = this.getDescricaoTipoEdital(novoTipo);

    const confirmouEtapa1 = await this.$bvModal.msgBoxConfirm(
      `Deseja alterar o tipo de edital de "${descricaoAnterior}" para "${descricaoNova}"?`,
      {
        buttonSize: "sm",
        cancelTitle: "Cancelar",
        cancelVariant: "outline-secondary",
        centered: true,
        headerBgVariant: "secondary",
        headerTextVariant: "light",
        okTitle: "Continuar",
        okVariant: "secondary",
        title: "Confirmar alteracao",
      }
    );

    if (!confirmouEtapa1) return false;

    return await this.$bvModal.msgBoxConfirm(
      "Essa troca pode impactar os cargos já cadastrados. Confirma a alteração?",
      {
        buttonSize: "sm",
        cancelTitle: "Não",
        cancelVariant: "outline-secondary",
        centered: true,
        headerBgVariant: "secondary",
        headerTextVariant: "light",
        okTitle: "Confirmar troca",
        okVariant: "danger",
        title: "Confirmacao final",
      }
    );
  }

  async getConcursoById(idEdital: number) {
    try {
      const response = await concursoService.getConcursoById(idEdital);
      if (!response) return this.$toast.error("Erro ao encontrar edital");
      this.edital = new EditalConcurso(response);
      if (this.edital.IdLicitacao !== null)
        this.LicitacaoSelecionada.value = this.edital.IdLicitacao;
      this.edital.DtProva = String(this.edital?.DtProva).split("T")[0];
      if (this.edital.DtProvaFinal) {
        this.edital.DtProvaFinal = String(this.edital.DtProvaFinal).split(
          "T"
        )[0] as any; // pega data final
        this.flPeriodoProva = this.edital.DtProvaFinal !== this.edital.DtProva;
      } else {
        this.flPeriodoProva = false;
      }

      this.periodoProva = {
        startDate: this.parseDateAsLocal(this.edital.DtProva),
        endDate: this.parseDateAsLocal(
          this.edital.DtProvaFinal ?? this.edital.DtProva
        ),
      };

      this.edital.DtPublicacao = String(this.edital.DtPublicacao).split("T")[0];
      this.edital.DtFimInscricao = String(this.edital.DtFimInscricao).split(
        "T"
      )[0];
      this.edital.DtInicioInscricao = String(
        this.edital.DtInicioInscricao
      ).split("T")[0];
      if (this.edital.DtValidade)
        this.edital.DtValidade = String(this.edital.DtValidade).split("T")[0];
      if (this.edital.DtHomologacao)
        this.edital.DtHomologacao = String(this.edital.DtHomologacao).split(
          "T"
        )[0];
      if (this.edital.DtCancelamento)
        this.edital.DtCancelamento = String(this.edital.DtCancelamento).split(
          "T"
        )[0];
    } catch (error: any) {
      this.tratarError(error);
    }
  }

  get prazoInscricaoInsuficiente(): boolean {
    if (this.edital.IdTipoEdital !== 1) return false;
    if (!this.edital.DtInicioInscricao || !this.edital.DtFimInscricao)
      return false;
    const inicio = this.parseDateAsLocal(this.edital.DtInicioInscricao);
    const fim = this.parseDateAsLocal(this.edital.DtFimInscricao);
    if (!inicio || !fim) return false;
    const diffDias = Math.round(
      (fim.getTime() - inicio.getTime()) / (1000 * 60 * 60 * 24)
    );
    return diffDias < 15;
  }

  async salvarEdital() {
    try {
      this.overlayCard = true;
      if (
        !this.habilitaIgesp &&
        this.edital.IdTipoRegime === 2 &&
        (this.LicitacaoSelecionada.value == null ||
          !(Number(this.LicitacaoSelecionada.value) > 0))
      )
        return this.$toast.error("Licitação não selecionada");
      const isValid = await this.validationobserver.validate();
      if (!isValid) {
        console.error(this.validationobserver);
      } else {
        this.campos.idTipoEdital = this.edital.IdTipoEdital;
        this.campos.idBanca =
          this.edital.IdTipoRegime === 2
            ? Number(this.BancaSelecionada.value)
            : null;
        this.campos.nrEdital = this.edital.NrEdital;
        this.campos.anoEdital = this.edital.AnoEdital;
        this.campos.validade = this.edital.Validade;
        this.campos.IdLicitacao =
          this.edital.IdTipoRegime === 2 &&
          Number(this.LicitacaoSelecionada.value) > 0
            ? Number(this.LicitacaoSelecionada.value)
            : null;
        this.campos.flPermiteProrrogacao = this.edital.FlPermiteProrrogacao;
        this.campos.dtPublicacao = String(
          this.formatDataDB(this.edital.DtPublicacao)
        );
        this.campos.dtInicioInscricao = String(
          this.formatDataDB(this.edital.DtInicioInscricao)
        );
        this.campos.dtFimInscricao = String(
          this.formatDataDB(this.edital.DtFimInscricao)
        );
        this.campos.dtProva = String(
          this.formatDataDB(
            this.flPeriodoProva
              ? this.periodoProva.startDate
              : this.edital.DtProva
          )
        );
        this.campos.dtProvaFinal = String(
          this.formatDataDB(
            this.flPeriodoProva
              ? this.periodoProva.endDate
              : this.edital.DtProva
          )
        );
        this.campos.DsDotacaoOrcamentaria = this.edital.DsDotacaoOrcamentaria;
        this.campos.DsAutorizacaoLDO = this.edital.DsAutorizacaoLDO;
        this.campos.dispensaLicitacao = this.edital.IdTipoRegime !== 2;
        this.campos.DsProvaOral = this.edital.DsProvaOral;
        this.campos.FlProvaOral = this.edital.FlProvaOral;
        this.campos.FlExamePsicotecnico = this.edital.FlExamePsicotecnico;
        this.campos.DsExamePsicotecnico = this.edital.DsExamePsicotecnico;
        this.campos.FlTempoExperienciaLei = this.edital.FlTempoExperienciaLei;
        this.campos.FlDevolucaoTaxaInscricao =
          this.edital.FlDevolucaoTaxaInscricao;
        this.campos.FlIsencao = this.edital.FlIsencao;
        this.campos.FlInscricaoEstrangeiros =
          this.edital.FlInscricaoEstrangeiros;
        this.campos.FlCritDesempateEstatutoIdoso =
          this.edital.FlCritDesempateEstatutoIdoso;
        this.campos.FlRecursosTodasFases = this.edital.FlRecursosTodasFases;
        this.campos.FlPublicacaoTodasFases = this.edital.FlPublicacaoTodasFases;
        this.campos.codLicitacaoIgesp = this.edital.CodLicitacaoIgesp;
        this.campos.FlVagasPcd = this.edital.FlVagasPcd;
        this.campos.DsVagasPcd = this.edital.DsVagasPcd;
        this.campos.FlVagasCotas = this.edital.FlVagasCotas;
        this.campos.DsVagasCotas = this.edital.DsVagasCotas;
        this.campos.DsTempoExperienciaLei = this.edital.DsTempoExperienciaLei;
        this.campos.codUgResponsavel = this.UGSelecionada.value
          ? String(this.UGSelecionada.value)
          : null;
        const response =
          this.idEdital > 0
            ? await concursoService.editarEdital(this.campos, this.idEdital)
            : await concursoService.criarEdital(this.campos);
        this.$emit("editalCriado", response);
        this.$emit("atualizar-cargos");
        this.$toast.success("Informações do Edital salvas com sucesso!");
        if (this.idEdital > 0) await this.loadData();
        return response;
      }
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.overlayCard = false;
    }
  }

  async adicionarInstituicao() {
    const isValid = await this.validationobserver.validate();
    if (!isValid) {
      this.$toast.error("Preencha todos os campos.");
      console.error(this.validationobserver);
    } else {
      try {
        const response = await concursoService.criarBanca(
          this.camposEnvioBanca
        );
        this.$toast.success("Instituição adicionada com sucesso!");
        await this.insituicoesSelect();
        this.BancaSelecionada.value = await response.IdBanca;
        this.BancaSelecionada.value = await response.NomeBanca;
        this.$bvModal.hide("modal-1");
      } catch (e: any) {
        this.tratarError(e);
      }
    }
  }

  async insituicoesSelect() {
    try {
      this.overlayBancaSelect = true;
      this.listaBancasGeral = await concursoService.getBancas();
      if (
        this.listaBancasGeral === null ||
        this.listaBancasGeral === undefined ||
        this.listaBancasGeral.length === 0
      )
        return this.$toast.error("Erro ao obter a lista de Bancas");
      this.listaBancasSelect = this.listaBancasGeral.map((b: Banca) => ({
        value: b.IdBanca,
        text: b.NomeBanca,
      }));
      this.listaBancasSelect.push({ text: "Outra", value: -1 });
      this.listaBancasSelect.unshift({
        text: "Selecione uma opção",
        value: null,
      });
    } catch (error: any) {
      this.tratarError(error);
    } finally {
      const bancaSelecionada = this.listaBancasSelect.find(
        (banca) => banca.value === this.edital.IdBanca
      );
      this.BancaSelecionada = bancaSelecionada
        ? {
            value: bancaSelecionada?.value,
            text: bancaSelecionada?.text,
          }
        : {
            value: null,
            text: "Selecione uma opção",
          };
      this.overlayBancaSelect = false;
    }
  }

  async getListarLicitacoes() {
    try {
      this.overlayLicitacoes = true;
      const cnpjBancaSelecionada = this.listaBancasGeral.find(
        (banca: Banca) => banca.IdBanca === Number(this.BancaSelecionada.value)
      )?.CnpjBanca;
      if (!cnpjBancaSelecionada) {
        this.listaLicitacoes = [{ text: "Selecione uma opção", value: null }];
        return;
      }
      const response = await concursoService.getListarLicitacoes(
        Number(cnpjBancaSelecionada)
      );
      if (response) {
        this.listaLicitacoes = response.map((pl: ProcessoLicitatorio) => ({
          text: `${pl.Descricao} - ${pl.Objeto}`,
          value: pl.IdLicitacao,
        }));
        this.listaLicitacoes.unshift({
          text: "Selecione uma opção",
          value: null,
        });
      }
    } catch (error: any) {
      this.tratarError(error);
    } finally {
      const licitacaoSelecionada = this.listaLicitacoes.find(
        (licitacao) => licitacao.value === this.edital.IdLicitacao
      );
      this.LicitacaoSelecionada = licitacaoSelecionada
        ? {
            value: licitacaoSelecionada?.value,
            text: licitacaoSelecionada?.text,
          }
        : {
            value: null,
            text: "Selecione uma opção",
          };
      this.overlayLicitacoes = false;
    }
  }

  async habilitaCodIgespLicitacao() {
    try {
      const response = await concursoService.getHabilitarCodIgespLicitacao();
      return response || false;
    } catch (error: any) {
      this.tratarError(error);
      return false;
    }
  }

  abrirModal() {
    if (this.BancaSelecionada.value === -1) {
      this.camposEnvioBanca.CnpjBanca = "";
      this.camposEnvioBanca.FoneBanca = "";
      this.camposEnvioBanca.NomeBanca = "";
      this.$bvModal.show("modal-1");
    }
  }

  fecharModal() {
    this.BancaSelecionada = { text: "Selecione uma opção", value: null };
    return this.$bvModal.hide("modal-1");
  }

  async onSelectBanca() {
    await this.getListarLicitacoes();
    this.abrirModal();
  }

  mudaFlPeriodo() {
    if (this.edital.IdTipoEdital === 1) this.flPeriodoProva = false;
  }
}
</script>

<style scoped>
:deep(#selectWrapper.invalid .multiselect__tags) {
  border: #dc3545 solid 1px !important;
  border-radius: 3px !important;
}

:deep(#selectWrapper.valid .multiselect__tags) {
  border: #28a745 solid 1px !important;
  border-radius: 3px !important;
}

:deep(#selectWrapper label) {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
  text-align: left;
}

:deep(#inputWrapper.invalid input) {
  border: #dc3545 solid 1px !important;
  border-radius: 3px !important;
}

:deep(#inputWrapper.valid input) {
  border: #28a745 solid 1px !important;
  border-radius: 3px !important;
}

:deep(#inputWrapper label) {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
  text-align: left;
}
</style>
